"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterContacts = void 0;
var react_1 = __importDefault(require("react"));
var FooterContacts_module_scss_1 = __importDefault(require("./FooterContacts.module.scss"));
var Svg_1 = require("../svg/Svg");
var transformPhoneNumber_1 = require("../../helpers/transformPhoneNumber");
var selectors_1 = require("../../redux/selectors");
var react_redux_1 = require("react-redux");
var FooterContacts = function () {
    var contacts = (0, react_redux_1.useSelector)(selectors_1.contactsSelector).contacts;
    var isLoading = (0, react_redux_1.useSelector)(selectors_1.contactsSelector).stateLoad.isLoading;
    var error = (0, react_redux_1.useSelector)(selectors_1.contactsSelector).stateLoad.error;
    if (error) {
        return react_1.default.createElement("div", null, "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0434\u0430\u043D\u043D\u044B\u0445");
    }
    return (react_1.default.createElement("article", { className: FooterContacts_module_scss_1.default.footer_contacts },
        react_1.default.createElement("ul", { className: FooterContacts_module_scss_1.default.footer_contacts__list },
            react_1.default.createElement("li", { className: FooterContacts_module_scss_1.default.footer_contacts__item },
                react_1.default.createElement(Svg_1.Logo, { className: FooterContacts_module_scss_1.default.footer_contacts__logo })),
            react_1.default.createElement("li", { className: FooterContacts_module_scss_1.default.footer_contacts__item },
                react_1.default.createElement("a", { href: "tel:+".concat(contacts.phone) }, isLoading ? '...' : (0, transformPhoneNumber_1.transformPhoneNumber)(contacts.phone))),
            react_1.default.createElement("li", { className: FooterContacts_module_scss_1.default.footer_contacts__item }, isLoading ? '...' : contacts.auto_address),
            react_1.default.createElement("li", { className: FooterContacts_module_scss_1.default.footer_contacts__item }, isLoading ? '...' : contacts.mode_operation))));
};
exports.FooterContacts = FooterContacts;
